<template>
  <div>
    <b-row
      class="justify-content-center m-2"
      :class="{ 'is-today': hours.weekdayCode === todayCode, 'is-open': hours.fromHour && hours.toHour }"
      v-for="(hours, key) in marketOpeningHours"
      :key="key"
    >
      <b-col cols="6" class="text-left">
        {{ hours.weekdayName }}
      </b-col>
      <b-col v-if="hours.fromHour && hours.toHour" cols="6">
        {{ hours.fromHour }} - {{ hours.toHour }}
      </b-col>
      <b-col v-else cols="6">
        <b>{{ $t('pages.login.user.card_opening_hours.market_closed') }}</b>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import moment from 'moment'
  import { OPENING_HOURS } from '@base/configs'

  export default {
    name: 'MarketOpeningHoursList',

    data () {
      return {
        marketOpeningHours: this.$_.cloneDeep(OPENING_HOURS),
        todayCode: moment().isoWeekday(),
      }
    },

    props: {
      market: {
        type: Object,
        required: true,
      }
    },

    created () {
      this.getMarketOpeningHours()
    },

    methods: {
      getMarketOpeningHours () {
        for (const openingHour of this.market.openingHours) {
          const oldOpeningHourObj = this.marketOpeningHours.find(
            obj => obj.weekdayCode === openingHour.weekdayCode
          )
          if (oldOpeningHourObj)
            Object.assign(oldOpeningHourObj, openingHour)
        }
      },
    }
  }
</script>

<style>

</style>
